// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sticky[data-v-3b7af979]{position:sticky;position:-webkit-sticky;top:0;margin-top:0;padding-top:0;z-index:999}", ""]);
// Exports
module.exports = exports;
